import '@/assets/styles/components/leave-countdown-button.styles.scss';
import { useCountdown } from '@/utility/use-util.tsx';
import { useEffect } from 'react';

type LeaveCountdownButtonProps = {
	onClose?: () => void;
};

export default function LeaveCountdownButton({ onClose }: LeaveCountdownButtonProps) {
	const { remainingSeconds, reset, start, isCompleted } = useCountdown(6 * 1000);

	useEffect(() => {
		start();

		return reset();
	}, []);

	useEffect(() => {
		if (isCompleted) {
			onClose?.();
		}
	}, [onClose, isCompleted]);

	return (
		<div className="leave-countdown-button">
			{remainingSeconds > 1 ? <i className="icons-clock-circle" /> : null}
			{remainingSeconds > 1 ? remainingSeconds - 1 : 'Görüşme Sonlandırılıyor...'}
		</div>
	);
}
